import React from 'react'
import { connect } from 'react-redux'
import UserForm from './UserForm'

const mapStateToProps = (state) => {
  return {
    current_user: state.auth.current_user.data,
  };
}

class ConnectedProfileEdit extends React.Component {
  render(){
    return <UserForm actionName="profile" user_id={this.props.current_user.id} headTitle="Profile"/>
  }
}

const ProfileEdit = connect(mapStateToProps,null)(ConnectedProfileEdit)
export default ProfileEdit



// WEBPACK FOOTER //
// ./src/js/components/ProfileEdit.js